const getStringBetween = (fullString: string, startString: string, endString: string) => {
    const startIndex = fullString.indexOf(startString) + startString.length
    const endIndex = fullString.indexOf(endString)
    return fullString.substring(startIndex, endIndex)
}

export default getStringBetween
